module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('section', {
    attrs: {
      "epub:type": "chapter",
      "title": "Note on Romanization"
    }
  }, [_c('h2', {
    staticClass: "fmhead"
  }, [_c('a', {
    attrs: {
      "id": "page_vii"
    }
  }), _vm._v("Note on Romanization")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("In romanization of Korean sources and Korean names, the McCune- Reischauer system is used; exceptions are some already commonly used spellings. In the Japanese case, the Hepburn system is adopted. In the Chinese case, the Pinyin system is adopted. Following the traditions of these countries, the family name appears first with the given name following; however, the spellings of personal names that appear in works in English are cited as in the originals.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("For the Indonesian case, the spelling of personal names, organizations, and publications prevalent at the time under discussion is retained. Sukarno’s name was spelled with a "), _c('em', [_vm._v("u")]), _vm._v(", but Soeharto’s name was officially spelled with the older "), _c('em', [_vm._v("oe")]), _vm._v(". In the Thai case, the guidelines of the Royal Institute, outlined in “Principles of Romanization for Thai Script by Transcription Method,” have been followed. The only exceptions to this are the names of individuals; if there is already a romanized name in use, that one is used in lieu of imposing the Royal Institute guidelines. In the Burmese case, all political groups have official names in both English and Burmese, so their official names are adopted. For personal names, the method used by the government media is followed."), _c('a', {
    attrs: {
      "id": "page_viii"
    }
  })])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5dcb2468","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/front01.vue
// module id = 72
// module chunks = 0